export default __webpack_public_path__ + "static/media/step-two-3.2685573c.jpg";